var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.75,
    y: 5.75,
    width: 10,
    height: 12,
    rx: 2,
    stroke: "#1a1a1a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 2.25C4.36929 2.25 3.25 3.36929 3.25 4.75V12.75C3.25 14.1307 4.36929 15.25 5.75 15.25H6.75V14.25H5.75C4.92157 14.25 4.25 13.5784 4.25 12.75V4.75C4.25 3.92157 4.92157 3.25 5.75 3.25H11.75C12.5784 3.25 13.25 3.92157 13.25 4.75V5.75H14.25V4.75C14.25 3.36929 13.1307 2.25 11.75 2.25H5.75Z",
    fill: "#1a1a1a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.7c3502b12066a15b70db4188f9227912.svg";
export { ForwardRef as ReactComponent };